import axios from "axios";
import { takeLatest, takeEvery, call, put, select, all } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../utils/queryParams.js";

export const SET_REVENUE_TYPES_CHECKED_SUCCESS =
  "saga/totalRevenue/SET_REVENUE_TYPES_CHECKED_SUCCESS";
export const SET_REVENUE_TYPES_CHECKED = "saga/totalRevenue/SET_REVENUE_TYPES_CHECKED";
export const SET_UPDATES_LOADING = "saga/totalRevenue/SET_UPDATES_LOADING";
export const SET_LOADING = "saga/totalRevenue/SET_LOADING";
export const SET_PREV_PAGE_FILTERS = "saga/totalRevenue/SET_PREV_PAGE_FILTERS";
export const SET_CHART_LOADING = "saga/totalRevenue/SET_CHART_LOADING";

export const FETCH_REVENUE_BY_TYPE_SUCCESS = "saga/totalRevenue/FETCH_REVENUE_BY_TYPE_SUCCESS";
export const FETCH_YEAR_OVER_YEAR_SUCCESS = "saga/totalRevenue/FETCH_YEAR_OVER_YEAR_SUCCESS";
export const FETCH_REVENUE_TYPES_SUCCESS = "saga/totalRevenue/FETCH_REVENUE_TYPES_SUCCESS";
export const FETCH_CURRENT_USER_SUCCESS = "saga/totalRevenue/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_REVENUE_SUCCESS = "saga/totalRevenue/FETCH_REVENUE_SUCCESS";
export const FETCH_CURRENT_USER = "saga/totalRevenue/FETCH_CURRENT_USER";

export const UPDATE_REVENUE_TYPES_SUCCESS = "saga/totalRevenue/UPDATE_REVENUE_TYPES_SUCCESS";
export const UPDATE_ALL_DATA_SUCCESS = "saga/totalRevenue/UPDATE_ALL_DATA_SUCCESS";
export const UPDATE_ALL_DATA = "saga/totalRevenue/UPDATE_ALL_DATA";
export const UPDATE_ROLLING_VIEW = "saga/totalRevenue/UPDATE_ROLLING_VIEW";

export const REMOVE_REVENUE_CATEGORY_SUCCESS = "saga/totalRevenue/REMOVE_REVENUE_CATEGORY_SUCCESS";
export const REMOVE_REVENUE_CATEGORY = "saga/totalRevenue/REMOVE_REVENUE_CATEGORY";

export const ADD_REVENUE_CHART_SUCCESS = "saga/totalRevenue/ADD_REVENUE_CHART_SUCCESS";
export const ADD_REVENUE_CHART = "saga/totalRevenue/ADD_REVENUE_CHART";

export const actionCreators = {
  setRevenueTypesChecked: createAction(SET_REVENUE_TYPES_CHECKED),
  removeRevenueCategory: createAction(REMOVE_REVENUE_CATEGORY),
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  addRevenueChart: createAction(ADD_REVENUE_CHART),
  updateAllData: createAction(UPDATE_ALL_DATA),
  updateRollingView: createAction(UPDATE_ROLLING_VIEW)
};

export default function* watchStars() {
  yield takeEvery(REMOVE_REVENUE_CATEGORY, removeRevenueCategory);
  yield takeLatest(ADD_REVENUE_CHART, updateRevenueTypesData);
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(UPDATE_ALL_DATA, updateAllData);
  yield takeLatest(UPDATE_ROLLING_VIEW, updateRollingView);
}

let date;
let revenueType;

export function* getCurrentUserData({ payload }) {
  yield put({ type: FETCH_CURRENT_USER_SUCCESS, payload: payload.user });
  yield put({
    type: SET_PREV_PAGE_FILTERS,
    payload: { prevDate: payload.date, prevRevenueType: payload.revenue_type }
  });
  date = payload.date || (yield select((state) => state.totalRevenue.currentUser.calendarEndDate));
  revenueType = payload.revenue_type;
  const { short_url, organization_id } = yield select((state) => state.commonReducer.commonProps);

  let params = { short_url, organization_id, date, revenue_type: payload.revenue_type };

  const allSagas = [
    getRevenueData(params),
    getRevenueByTypeData(params),
    fetchRevenueTypesData(params),
    getYearOverYearData(params)
  ];
  try {
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* updateRollingView() {
  const { short_url, organization_id } = yield select((state) => state.commonReducer.commonProps);
  let params = { short_url, organization_id, date, revenue_type: revenueType };

  yield getYearOverYearData(params);
}

export function* updateAllData({ payload }) {
  yield put({ type: SET_LOADING, payload: true });
  yield put({
    type: SET_PREV_PAGE_FILTERS,
    payload: { prevDate: payload.date, prevRevenueType: payload.revenue_type }
  });

  date = payload.date;
  revenueType = payload.revenue_type;
  const { short_url, organization_id } = yield select((state) => state.commonReducer.commonProps);
  let params = { short_url, organization_id, date, revenue_type: payload.revenue_type };

  const allSagas = [
    getRevenueData(params),
    getRevenueByTypeData(params),
    getYearOverYearData(params),
    fetchRevenueTypesData(params)
  ];
  try {
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* getRevenueData(params) {
  try {
    const revenueResponse = yield call(
      axios.get,
      queryParams.apiVersion + "pages/my_dashboard/total_revenue/totals",
      {
        params
      }
    );
    yield put({ type: FETCH_REVENUE_SUCCESS, payload: revenueResponse.data });
  } catch (error) {
    console.error(error);
  }
}

export function* getRevenueByTypeData(params) {
  try {
    const revenueByTypeResponse = yield call(
      axios.get,
      queryParams.apiVersion + "pages/my_dashboard/total_revenue/revenue_by_type",
      { params }
    );
    yield put({
      type: FETCH_REVENUE_BY_TYPE_SUCCESS,
      payload: revenueByTypeResponse.data
    });
  } catch (error) {
    console.error(error);
  }
}

export function* fetchRevenueTypesData(params) {
  try {
    const { data } = yield call(
      axios.get,
      queryParams.apiVersion + "pages/my_dashboard/total_revenue/settings/revenue_types",
      { params }
    );

    yield put({
      type: FETCH_REVENUE_TYPES_SUCCESS,
      payload: data
    });
  } catch (error) {
    console.error(error);
  }
}

export function* updateRevenueTypesData() {
  const { short_url, organization_id } = yield select((state) => state.commonReducer.commonProps);
  const checkedRevenueTypeIds = yield select((state) => state.totalRevenue.checkedRevenueTypeIds);

  const params = {
    short_url,
    organization_id,
    date,
    default_revenue_type_ids: checkedRevenueTypeIds.length
      ? checkedRevenueTypeIds.map((rev) => ({ id: rev.id, type: rev.type }))
      : [""],
    revenue_type: revenueType
  };

  try {
    yield put({ type: SET_UPDATES_LOADING, payload: true });
    const { data } = yield call(
      axios.post,
      queryParams.apiVersion + "pages/my_dashboard/total_revenue/settings/revenue_types",
      { ...params, revenue_type: revenueType }
    );

    yield put({ type: UPDATE_REVENUE_TYPES_SUCCESS, payload: data });
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* getYearOverYearData(params) {
  const rolling_view = yield select((state) => state.totalRevenue.rolling_view);

  yield put({ type: SET_CHART_LOADING, payload: true });
  try {
    const yearOverYearResponse = yield call(
      axios.get,
      queryParams.apiVersion + "pages/my_dashboard/total_revenue/year_over_year_revenues",
      { params: { ...params, rolling_view } }
    );
    yield put({ type: FETCH_YEAR_OVER_YEAR_SUCCESS, payload: yearOverYearResponse.data });
    yield put({ type: SET_CHART_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* removeRevenueCategory() {
  const revenuesByType = yield select((state) => state.totalRevenue.revenuesByType);
  const { short_url, organization_id } = yield select((state) => state.commonReducer.commonProps);

  let params = {
    short_url,
    organization_id,
    date,
    default_revenue_type_ids: revenuesByType.length
      ? revenuesByType.map((rev) => ({ id: rev.id, type: rev.type }))
      : [""],
    revenue_type: revenueType
  };

  try {
    const response = yield call(
      axios.post,
      queryParams.apiVersion + "pages/my_dashboard/total_revenue/settings/revenue_types",
      params
    );
    yield put({ type: REMOVE_REVENUE_CATEGORY_SUCCESS, payload: response.data });
  } catch (error) {
    console.error(error);
  }
}
